import type { BoxProps } from '@hover/blueprint';
import { Body, Box, Heading } from '@hover/blueprint';
import React from 'react';

import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

interface ProjectDetailsProps extends BoxProps {
  name: string;
  areas: string[];
}

const ProjectDetails = ({ name, areas, ...rest }: ProjectDetailsProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  return (
    <Box flexDirection="column" {...rest}>
      <Heading mb={50} size={200}>
        {t('projects.project')}
      </Heading>
      <Heading noOfLines={2}>{name}</Heading>
      <Box pt={300}>
        <Body isBold pr={100}>
          {t('projects.area')}
        </Body>
        <Body
          color="neutral.600"
          sx={{
            ':first-letter': {
              textTransform: 'capitalize',
            },
          }}
        >
          {areas.join(', ').replaceAll('_', ' ')}
        </Body>
      </Box>
    </Box>
  );
};

export { ProjectDetails };
